import { Injectable } from '@angular/core'
import Swal from 'sweetalert2'
import { environment } from '../../../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class SwalService {

    constructor() {
    }

    static closeAlert() {
        Swal.close()
    }

    static getSwalTitle() {
        return Swal.getTitle()
    }

    static input(title: string) {
        return Swal.fire({
            title,
            input: 'text',
            inputAttributes: {
                autocapitalize: 'off'
            },
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Ok!',
            showLoaderOnConfirm: true,
            preConfirm: (value) => {
                return value
            },
            allowOutsideClick: () => !Swal.isLoading()
        })
    }

    static error(title: string = 'Error', text: string = 'Hubo un problema al realizar el proceso') {
        return Swal.fire({
            icon: 'error',
            title: `${title}`,
            text: `${text}`
        })
    }

    static confirm(title: string, text: string) {
        return Swal.fire({
            title: `${title}`,
            text: `${text}`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, de acuerdo!',
            cancelButtonText: 'No, cancelar'
        })
    }

    static warningBlock(title: string = 'Procesando datos', text: string = 'Espere por favor') {
        return Swal.fire({
            title,
            html:
                text + '</br>' +
                '<i class="fa fa-refresh fa-spin fa-5x m-3" style="color: #2D3E63"></i>',
            icon: 'warning',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false,
            showCancelButton: false,
        })
    }

    static progressBlock(title: string = 'Progreso 0%', text: string = 'Espere por favor') {
        return Swal.fire({
            title,
            html:
                text +
                `
                <div class="text-primary wrapper-icon">
                    <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
                </div>
                `,
            showCancelButton: false,
            showConfirmButton: false,
            allowEscapeKey: false,
            allowOutsideClick: false,
        });
    }

    static LoadingLogo(title: string = 'Procesando datos', text: string = 'Espere por favor') {
        return Swal.fire({
            title,
            html:
                text +
                '</br>' +
                `<div id="initial_startup">
                    <div class="graphic">
                        <object class="wrapper-svg" data="${environment.logoSvg}" width="300" height="300">
                        </object>
                    </div>
                </div>`,
            showCancelButton: false,
            showConfirmButton: false,
            allowEscapeKey: false,
            allowOutsideClick: false,
        })
    }

    static warningBlockLogo(title: string) {
        return Swal.fire({
            // title,
            html: `
            <div class="fade-in-out pt-2">
                <div class="slide-in-down">
                    <figure>
                        <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="1in" height="0.41887in" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
                            viewBox="0 0 49.68 36.35">
                        <defs>
                        <style type="text/css">
                        <![CDATA[.fil0 {fill:#CC943B}]]>
                        </style>
                        </defs>
                        <g id="Layer_x0020_1">
                        <metadata id="CorelCorpID_0Corel-Layer"/>
                        <path class="fil0" d="M5.87 8.63c1.46,0 2.64,1.18 2.64,2.64 0,1.46 -1.18,2.64 -2.64,2.64 -1.46,0 -2.64,-1.18 -2.64,-2.64 0,-1.46 1.18,-2.64 2.64,-2.64zm-0.68 8.4c0.36,0.04 0.7,-0.01 1.02,-0.12 0.75,1.81 1.86,3.62 3.3,5.01 1.74,1.68 3.95,2.77 6.6,2.64 2.92,-0.15 5.43,-1.85 7.19,-4.5 0.76,-1.15 1.38,-2.49 1.83,-3.97 0.41,1.41 0.96,2.7 1.63,3.81 1.65,2.74 4.05,4.52 6.82,4.66 2.56,0.13 4.75,-0.78 6.54,-2.44 0.19,-0.18 0.38,-0.37 0.57,-0.57 -2.56,10.28 -6.31,9.79 -10.5,9.25 -1.5,-0.19 -3.03,-0.39 -4.67,-0.34 -1.75,0.06 -3.37,0.38 -4.95,0.69 -4.55,0.89 -8.8,1.72 -11.4,-8.37 -0.31,-1.21 -1.54,-1.94 -2.74,-1.63 -1.21,0.31 -1.94,1.54 -1.63,2.74 3.67,14.24 9.93,13.01 16.64,11.7 1.44,-0.28 2.91,-0.57 4.22,-0.61 1.29,-0.04 2.64,0.13 3.96,0.3 7.17,0.93 13.47,1.74 16.65,-18.74 0.74,-0.34 1.39,-0.82 1.92,-1.42 0.92,-1.03 1.48,-2.39 1.48,-3.88 0,-1.61 -0.65,-3.07 -1.71,-4.13 -1.06,-1.06 -2.51,-1.71 -4.13,-1.71 -1.61,0 -3.07,0.65 -4.13,1.71 -1.06,1.06 -1.71,2.51 -1.71,4.13 0,1.94 0.72,2.98 1.4,3.71 -0.59,1.62 -1.39,2.95 -2.37,3.86 -0.9,0.84 -1.99,1.3 -3.23,1.24 -1.16,-0.06 -2.28,-1.01 -3.17,-2.48 -0.9,-1.49 -1.51,-3.43 -1.7,-5.58 0.63,-0.41 1.14,-0.92 1.55,-1.56 0.67,-1.04 0.97,-2.3 0.97,-3.82 0,-1.73 -0.76,-3.42 -1.99,-4.65 -1.18,-1.18 -2.81,-1.96 -4.62,-1.96 -1.82,0 -3.48,0.74 -4.67,1.94 -1.2,1.2 -1.94,2.85 -1.94,4.67 0,1.48 0.49,2.85 1.33,3.96 0.48,0.64 1.07,1.19 1.75,1.61 -0.2,2.1 -0.84,3.97 -1.78,5.39 -0.97,1.47 -2.26,2.4 -3.65,2.48 -1.24,0.06 -2.33,-0.5 -3.24,-1.38 -1.02,-0.98 -1.81,-2.33 -2.33,-3.68 0.23,-0.28 0.44,-0.58 0.62,-0.89 0.48,-0.85 0.75,-1.82 0.75,-2.85 0,-1.61 -0.65,-3.07 -1.71,-4.13 -1.06,-1.06 -2.51,-1.71 -4.13,-1.71 -1.61,0 -3.07,0.65 -4.13,1.71 -1.06,1.06 -1.71,2.51 -1.71,4.13 0,1.49 0.56,2.85 1.48,3.88 0.93,1.04 2.23,1.75 3.7,1.92zm19.67 -7.83c-1.47,0 -2.65,-1.19 -2.65,-2.65 0,-1.47 1.19,-2.65 2.65,-2.65 1.47,0 2.65,1.19 2.65,2.65 0,1.47 -1.19,2.65 -2.65,2.65zm17.25 2.02c0,-0.97 0.79,-1.75 1.75,-1.75 0.97,0 1.75,0.79 1.75,1.75 0,0.97 -0.79,1.75 -1.75,1.75 -0.97,0 -1.75,-0.79 -1.75,-1.75z"/>
                        </g>
                        </svg>
                    </figure>
                </div>
                <div style="margin-top: -10px">
                    <figure>
                        <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="1.10172in" height="0.940287in" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd" viewBox="0 0 11.5 9.81">
                        <defs>
                        <style type="text/css">
                        <![CDATA[.fil0 {fill:#CC943B;fill-rule:nonzero}]]>
                        </style>
                        </defs>
                        <g id="Layer_x0020_1">
                        <metadata id="CorelCorpID_0Corel-Layer"/>
                        <path class="fil0" d="M3.74 5.8c-0.03,0.68 -0.09,1.36 -0.38,1.98 -0.22,0.48 -0.61,0.73 -1.16,0.6 -0.55,-0.13 -0.85,-0.56 -0.79,-1.16 0.02,-0.15 0.08,-0.31 0.13,-0.46 0.12,-0.37 0.17,-0.74 -0.26,-0.92 -0.46,-0.19 -0.75,0.12 -0.99,0.46 -0.18,0.27 -0.26,0.58 -0.29,0.9 -0.08,1.02 0.5,1.98 1.45,2.39 1.01,0.44 2.11,0.19 2.81,-0.66 0.44,-0.54 0.63,-1.19 0.72,-1.87 0.15,-1.19 0.15,-2.38 0.08,-3.58 -0.06,-0.89 -0.3,-1.82 0.3,-2.66 0.14,-0.2 0.08,-0.46 -0.12,-0.65 -0.19,-0.18 -0.43,-0.25 -0.65,-0.1 -0.65,0.46 -1.32,0.87 -2.15,0.93 -0.2,0.01 -0.33,0.21 -0.36,0.43 -0.04,0.27 0.07,0.48 0.3,0.59 0.41,0.21 0.91,0.1 1.13,0.38 0.27,0.36 0.25,2.88 0.22,3.39z"/>
                        <path class="fil0" d="M11.02 4.76c-0.27,-0.06 -0.47,0.08 -0.61,0.28 -0.18,0.26 -0.32,0.56 -0.52,0.8 -0.57,0.68 -1.63,0.85 -2.26,0.38 -0.65,-0.48 -0.8,-1.69 -0.3,-2.4 0.23,-0.33 0.49,-0.55 0.84,-0.11 0.19,0.24 0.44,0.37 0.72,0.15 0.34,-0.26 0.33,-0.61 0.17,-0.97 -0.36,-0.81 -1.3,-1.03 -2.13,-0.51 -1.02,0.66 -1.51,2.1 -1.14,3.39 0.39,1.34 1.33,2.08 2.98,2.11 0.89,-0.01 1.78,-0.53 2.42,-1.49 0.29,-0.43 0.58,-1.46 -0.18,-1.63z"/>
                        </g>
                        </svg>
                    </figure>
                </div>
            </div>
            <h3 style="color: #CC943B; font-family: Comfortaa, Helvetica, Arial, sans-serif">${title}</h3>
            <div class="rotate"><i class="bi-arrow-repeat m-3" style="color: #CC943B"></i></div>
            `,
            background: '#0b1826',
            // icon: 'warning',
            timerProgressBar: true,
            allowOutsideClick: false,
            showConfirmButton: false,
            showCancelButton: false,
        })
    }

    static success(title: string = 'Exito', text: string = 'La operación fue satisfactoria') {
        return Swal.fire({
            position: 'center',
            icon: 'success',
            title,
            text: `${text}`,
            showConfirmButton: true,
            showCancelButton: false,
            allowOutsideClick: false,
            confirmButtonText: '<i class="fa fa-thumbs-up"></i> Aceptar',
            allowEscapeKey: true
        })
    }

    static showAdvise(title: string, text: string) {
        return Swal.fire({
            position: 'center',
            title: `${title}`,
            text: `${text}`,
            showConfirmButton: true,
            allowOutsideClick: true,
        })
    }

    static warning(title: string, text: string) {
        return Swal.fire({
            position: 'center',
            icon: 'warning',
            title,
            html: text,
            // text: `${text}`,
            showConfirmButton: true,
            showCancelButton: false,
            allowOutsideClick: false,
            confirmButtonText: '<i class="fa fa-thumbs-up"></i> OK',
            allowEscapeKey: true
        })
    }

    static warningSure(title: string, text: string) {
        return Swal.fire({
            title,
            text: `${text}`,
            icon: 'question',
            showCancelButton: true,
            showConfirmButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#dc3545',
            allowEscapeKey: false,
            allowOutsideClick: false,
            confirmButtonText: 'Eliminar',
            cancelButtonText: 'Cancelar'
        })
    }
}
